// extracted by mini-css-extract-plugin
export default {"experienceRow":"_3Qzr4Q5v","skillName":"_2AFKQPu7","black":"_3TKV3LhQ","greyedOut":"Re-pduDr","fade":"_35p2jipE"};